// S2-FE2: Card
import './Card.css';

export interface CardProps {
  variant?: 'standard' | 'accent' | 'elevated';
  padding?: 'compact' | 'default' | 'spacious';
  children: React.ReactNode;
  className?: string;
}

export function Card({
  variant = 'standard',
  padding = 'default',
  children,
  className = '',
}: CardProps) {
  const classNames = [
    'airgent-card',
    `airgent-card-${variant}`,
    `airgent-card-${padding}`,
    className,
  ]
    .filter(Boolean)
    .join(' ');

  return <div className={classNames}>{children}</div>;
}
